<template>

<tippy arrow :placement='placement' theme="light" trigger="click" interactive :duration="[0,0]" delay="0" ref='notes'>
  <template v-slot:trigger>
    <div style='cursor: pointer' @click="expanded()"  title="Notes">
      <slot></slot>
      <div class='icon small'>
	<img src="/files/backend/icons/chat.svg" />
      </div>
    </div>
  </template>
  <div style="display: flex; flex-direction: column">
    <h3 style='margin: 0; display: flex; align-items: center'>
      <div style="width: 26px"></div>
      <div class='spacer'>{{my_account_name}} Notes</div>
      <div class='icon small' title="Close" @click="$refs['notes'].tip.hide()">
	<img src="/files/backend/icons/cancel.svg" />
      </div>
    </h3>
    <div v-if="loading" style='text-align: center'>
      <img  src="/files/imgs/loading.svg" style='height: 20px' />
    </div>
    <div v-if="my_comments===null"></div>
    <div v-else-if="my_comments.length===0" style='text-align: left'>No Notes</div>
    <div v-else v-for="comment in my_comments" style='text-align:left; margin: 10px 0'>
      <div class='date' style='text-align:center'>{{moment(comment.timestamp).format('LLL')}}</div>
      <div class='name' style='font-weight: bold; display: flex; align-items: center'>
	<div>{{comment.user.first_name}} {{comment.user.last_name}}</div>
	<div class='spacer'></div>
	<div class='icon small' title='Delete' v-if='comment.user.id===$store.state.user.id' type='button' @click="delete_comment(comment.id)"><img src="/files/backend/icons/delete.svg"/></div>
      </div>
      <div class='text' v-html="comment.comment"></div>
    </div>
    <textarea v-model='new_comment'></textarea>
    <button @click='submit_comment' :disabled='submitting'>Add Note</button>
  </div>
</tippy>
</template>

<script>
export default {
    name: "account-comments",
    props: {
	account_id: {
	    required: true
	},
	account_name: {
	    type: String,
	},
	placement: {
	    type: String,
	    default: 'right'
	},
	comments: {
	    type: Array,
	    default: null,
	}
    },
    data: function() { return {
	new_comment: "",
	my_comments: null,
	my_account_name: "",
	loading: false,
	submitting: false,
    }},
    methods: {
	expanded: function() {
	    if(this.my_comments == null) {
		this.get_comments()
	    }
	},
	delete_comment: function(comment_id) {
	    if(!confirm("Are you sure you want to delete this comment?")) {
		return
	    }
	    var self=this
	    self.loading=true
	    self.rpc("books","Accounts","del_comment",{account_id:this.account_id, comment_id:comment_id},"__bg__")
		.then(function(data) {
		    self.loading=false
		    if(data) {
			self.my_comments.splice(self.my_comments.findIndex(c => c.id == comment_id), 1)
		    }
		})
		.catch(function(error) {
		    self.loading=false
		    self.$store.commit("showError", error)
		})
	    
	},
	submit_comment: function() {
	    if(this.new_comment === "") {
		return
	    }
	    this.submitting=true
	    var self=this
	    self.rpc("books","Accounts","add_comment",{account_id:this.account_id, comment:this.new_comment},"__bg__")
		.then(function(data) {
		    self.my_comments.unshift(data["comment"])
		    self.new_comment = ""
		    self.submitting=false
		})
		.catch(function(error) {
		    self.submitting=false
		    self.$store.commit("showError", error)
		})
	},
	get_comments: function() {
	    var self=this
	    this.loading=true
	    self.rpc("books","Accounts","get_comments",{account_id:this.account_id},"__bg__")
		.then(function(data) {
		    self.loading=false
		    self.my_comments = data["comments"]
		    self.my_account_name = data.account.name
		})
		.catch(function(error) {
		    self.loading=false
		    self.$store.commit("showError", error)
		})
	},
    },
    mounted: function() {
	if(this.comments != null) {
	    this.my_comments = this.comments.slice() // shallow copy
	}
	if(this.account_name != null) {
	    this.my_account_name = this.account_name
	}
    }
}
</script>

<style scoped>
</style>
